module.exports = __webpack_public_path__ + "static/media/saulo-costa.a4af29c4.png";